import qs from "qs"

export const paramsSerializer = params => {
  return qs.stringify(params)
}



// WEBPACK FOOTER //
// ./src/utils/api.utils.js